import React from "react";
import { Box, Text, Typography, HStack } from "components/ui";
import ESGMetricCard from "./ESGMetricCard";
import { SustainabilityDashboardRead } from "store/abcoApi";

interface ESGImprovementsSectionProps {
	data: SustainabilityDashboardRead
}

const ESGImprovementsSection: React.FC<ESGImprovementsSectionProps> = ({
	data,
}) => {
	const currentYear = data.currentYear || {};
	const previousYear = data.previousYear || {};

	const handleInfoClick = (metric: string) => {
		// TODO: Implement info modal or tooltip
		console.log(`Info clicked for ${metric}`);
	};

	return (
		<Box>
			<Box justifyContent="center" gap={20} alignItems="center" mb={24}>
				<Typography.H3>Contributions and reductions</Typography.H3>
				<Typography sx={{ fontFamily: "calibri", textAlign: "center" }}>
					{data.currentYear?.totalOrders} orders have generated the following ESG improvements this financial year
				</Typography>
			</Box>
			
			<Box>
				{/* Carbon Offset Tons */}
				<ESGMetricCard
					title="Carbon Offset Tons"
					currentValue={currentYear.carbonOffsetTons || 0}
					previousValue={previousYear.carbonOffsetTons || 0}
					unit=" tons"
					onInfoClick={() => handleInfoClick("carbonOffsetTons")}
				/>
				
				<ESGMetricCard
					title="Made Blue Water Contribution"
					currentValue={currentYear?.litresOfCleanDrinkingWater || 0}
					previousValue={previousYear.litresOfCleanDrinkingWater || 0}
					unit=" litres"
					onInfoClick={() => handleInfoClick("waterContribution")}
				/>

				<ESGMetricCard
					title="Ilf Books Donated"
					currentValue={currentYear?.booksDonated || 0}
					previousValue={previousYear.booksDonated || 0}
					unit=" books"
					onInfoClick={() => handleInfoClick("books donated")}
				/>
				

			</Box>
			
			<Box  >
				<HStack justifyContent="center" gap={16} alignItems="center">
					<HStack alignItems="center" gap={6}>
						<Box width={16} height={2} bgColor="#FF6B35" borderRadius={1} />
						<Text fontSize={12} color="#666">
							Previous year
						</Text>
					</HStack>
					<HStack alignItems="center" gap={6}>
						<Box width={16} height={8} bgColor="#007AFF" borderRadius={2} />
						<Text fontSize={12} color="#666">
							Current year
						</Text>
					</HStack>
				</HStack>
			</Box>
		</Box>
	);
};

export default ESGImprovementsSection;
